import { Dialog, DialogContent } from '@mui/material';
import { PartnerOffers } from 'types/graphql';

import ViewOffers from '../ViewOffers/ViewOffers';

interface OffeerDialogProps {
    isOpen: boolean;
    handleClose: () => void;
    offer?: PartnerOffers;
}

const OfferPreviewDialog = ({ isOpen, handleClose, offer }: OffeerDialogProps) => {
    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="view-offer-dialog"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    padding: '0px',
                },
            }}
        >
            <DialogContent
                sx={{
                    padding: '0px',
                }}
            >
                <ViewOffers offer={offer} handleClose={handleClose} />
            </DialogContent>
        </Dialog>
    );
};
export default OfferPreviewDialog;
